import React, { createContext, useState, memo } from "react";
import layout2Settings from "./GullLayout/Layout2/Layout2Settings";

export const AppContext = createContext();

const AppProvider = ({ children }) => {
  
  //#region Layout Settings
  const [layoutSettings, setLayoutSettings] = useState( layout2Settings);
  //#endregion
  //#region Exported State
  const [user, setUser] = useState({});
  const [navData, setNavData] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  //#endregion
  //#region Provided Context Value
  const appContextValue = {
    layoutSettings,
    setLayoutSettings,
    isLoggedIn,
    user,
    setUser,
    navData,
    setNavData,
  };
  //#endregion

  return (
    <AppContext.Provider value={appContextValue}>
      {children}
    </AppContext.Provider>
  );
};

export default memo(AppProvider);
